/** Standing: the standing's status icon and its word, the same everywhere, drawn like the reference's ticket status. Children replace the word ("Lapsed 40 days"). */
import type { ReactNode } from "react";
import { cx } from "./cx";
import { Icon, type IconName } from "./icons";

export type StandingValue = "active" | "lapsed" | "suspended" | "non_member";

export const STANDING_LABEL: Record<StandingValue, string> = {
  active: "Active",
  lapsed: "Lapsed",
  suspended: "Suspended",
  non_member: "Non-member",
};

const ICON: Record<StandingValue, IconName> = {
  active: "status-delivered",
  lapsed: "status-progress",
  suspended: "feed-alert",
  non_member: "user-card",
};

export function Standing({ value, children, className }: { value: StandingValue; children?: ReactNode; className?: string }) {
  return (
    <span data-standing={value} className={cx("inline-flex items-center gap-2 whitespace-nowrap text-body leading-none text-cell-foreground", className)}>
      <Icon name={ICON[value]} />
      {children ?? STANDING_LABEL[value]}
    </span>
  );
}
